import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  const t = theme.typography as unknown as Record<string, unknown>;
  return {
    large: (t.sectionSubtitle || {}) as Record<string, unknown>,
    medium: (t.sectionSubtitleMedium || {}) as Record<string, unknown>,
    small: (t.sectionSubtitleSmall || {}) as Record<string, unknown>,
  };
});

interface SectionSubtitleProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  component?: React.ElementType;
  size?: 'large' | 'medium' | 'small';
}

export default function SectionSubtitle({
  id,
  className = '',
  children,
  component: Component = 'p',
  size = 'medium',
}: SectionSubtitleProps) {
  const classes = useStyles();
  return (
    <Component id={id} className={`${classes[size]} ${className}`.trim()}>
      {children}
    </Component>
  );
}
